import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const UsersPage = lazy(() =>
  import('./pages/UsersPage').then((m) => ({ default: m.UsersPage })),
);
const AuditPage = lazy(() =>
  import('./pages/AuditPage').then((m) => ({ default: m.AuditPage })),
);

// Access control (admin-only) is enforced centrally by the RBAC route guard in
// CrmShell (see ROUTE_ACCESS), so these stay plain route definitions.
export const usersRoutes: RouteObject[] = [
  { path: '/users', element: <UsersPage /> },
  { path: '/users/audit', element: <AuditPage /> },
];
